import { startOfDay, subMilliseconds, isEqual } from 'date-fns';

export default function vuexPlugin({state, commit }) {
    commit('today/update', today(state.options.startNextDay));

    setInterval(() => {    
        const newDate = today(state.options.startNextDay);
        if (!isEqual(newDate, state.today.value))
            commit('today/update', newDate);
    }, 1000);
    
    function today(subMs = 0) {
        return startOfDay(subMilliseconds(new Date(), subMs));
    }
}